import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
const tones = {
    slate: "bg-slate-100 text-slate-700 border-slate-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    rose: "bg-rose-50 text-rose-700 border-rose-200",
    indigo: "bg-indigo-50 text-indigo-700 border-indigo-200",
    teal: "bg-teal-50 text-teal-700 border-teal-200",
};
export function Badge({ tone = "slate", children, className, }) {
    return (_jsx("span", { className: clsx("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium", tones[tone], className), children: children }));
}
export function StatusBadge({ status }) {
    const tone = status === "Draft"
        ? "slate"
        : status === "Submitted"
            ? "amber"
            : status === "Approved"
                ? "emerald"
                : "rose";
    return _jsx(Badge, { tone: tone, children: status });
}
export function BillingBadge({ billable }) {
    return _jsx(Badge, { tone: billable ? "teal" : "slate", children: billable ? "Billable" : "Non-billable" });
}
